angular.module("app").component("recoverComponent", {
  templateUrl: "app/components/recover/recover.tmpl.html",
  controller: function ($http, appConfig) {
    const self = this;
    self.successRequest = false;
    self.email = "";
    self.error = false;
    self.busy = false;

    self.onSendLoginClick = () => {
      if (self.busy) return;
      const email = (self.email || "").trim();
      self.error = false;
      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        self.error = "Please enter the email address you use for Huedata.";
        return;
      }
      self.busy = true;
      $http
        .get(appConfig.dashboardServiceUrl + "api/users/recovery?email=" + encodeURIComponent(email))
        .then((res) => {
          if (res.data && res.data.success) {
            self.sentTo = email;
            self.successRequest = true;
          } else {
            self.error = "We couldn't find a Huedata account for that email. Check the spelling or sign up.";
          }
        })
        .catch((err) => {
          if (err && err.status === 422 && err.data && err.data.errors) {
            self.error = [].concat(err.data.errors).join(" ");
          } else if (err && err.status === 404) {
            self.error = "We couldn't find a Huedata account for that email. Check the spelling or sign up.";
          } else {
            self.error = "Something went wrong on our side. Please try again in a moment.";
          }
        })
        .finally(() => { self.busy = false; });
    };
  },
});
